/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2019 soho team All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : 发票/费用单据/无票收入模块接口</li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2026年09月23日</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import Ajax from '../js/common/ajax';

export default {
	//发票（direction：1销项 2进项，output/input 共用一组方法）
	invoice: {
		list(params = {}) {
			return Ajax.get('/invoice', params)
		},
		//按方向汇总张数与价税合计（默认排除作废/全额红冲）
		summary(params = {}) {
			return Ajax.get('/invoice/summary', params)
		},
		get(id) {
			return Ajax.get(`/invoice/${id}`)
		},
		save(p) {
			return Ajax.post('/invoice', p)
		},
		update(p) {
			return Ajax.put('/invoice', p)
		},
		delete(id) {
			return Ajax.delete(`/invoice/${id}`)
		},
		//生成凭证
		generateVoucher(id) {
			return Ajax.post(`/invoice/generateVoucher/${id}`)
		},
		//批量生成凭证
		batchGenerateVoucher(ids) {
			return Ajax.post('/invoice/batchGenerateVoucher', {ids})
		},
		//进项发票勾选认证
		check(id) {
			return Ajax.post(`/invoice/check/${id}`)
		},
		//导入模板下载地址
		template() {
			return `/api/invoice/template`
		},
		//Excel 导入发票（direction 1销项 2进项）
		importInvoices(direction, formData) {
			return Ajax.post(`/invoice/import?direction=${direction}`, formData,
				{'Content-Type': 'multipart/form-data'})
		},
		//上传附件
		uploadAttachment(id, formData) {
			return Ajax.post(`/invoice/attachment/${id}`, formData,
				{'Content-Type': 'multipart/form-data'})
		},
		//附件下载/预览地址
		attachmentUrl(id) {
			return `/api/invoice/attachment/${id}`
		},
		//进项发票生成入库单
		generateInbound(ids) {
			return Ajax.post('/invoice/inbound', {ids})
		}
	},
	//费用单据
	expense: {
		list(params = {}) {
			return Ajax.get('/expense-bill', params)
		},
		save(p) {
			return Ajax.post('/expense-bill', p)
		},
		update(p) {
			return Ajax.put('/expense-bill', p)
		},
		delete(id) {
			return Ajax.delete(`/expense-bill/${id}`)
		},
		generateVoucher(id) {
			return Ajax.post(`/expense-bill/generateVoucher/${id}`)
		}
	},
	//无票收入
	nonIncome: {
		list(params = {}) {
			return Ajax.get('/non-income', params)
		},
		save(p) {
			return Ajax.post('/non-income', p)
		},
		update(p) {
			return Ajax.put('/non-income', p)
		},
		delete(id) {
			return Ajax.delete(`/non-income/${id}`)
		},
		generateVoucher(id) {
			return Ajax.post(`/non-income/generateVoucher/${id}`)
		}
	}
};
